import React from 'react';
import Header from '../Components/Header/Header';
import FAQ from '../Components/FAQ/FAQ';
import Footer from '../Components/Footer/Footer';



const HomePage = () => {
  return (
    <div>
      <Header />
      <FAQ/>
      <Footer />
      
    </div>
  );
};

export default HomePage;
